module.exports = __webpack_public_path__ + "img/作战行动.cd9ccc35.png";